export default __webpack_public_path__ + "static/media/O-061.fc6d9ae2.png";